// @ts-nocheck
/* eslint-disable */
export const flTransferVerticalSquareIcon = {
    data: `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.4444 4.33115L15 7.88672L5.2222 7.88672" stroke="currentColor" stroke-width="1.6"/><path d="M8.77776 15L5.2222 11.4444L15 11.4444" stroke="currentColor" stroke-width="1.6"/></svg>`,
    name: 'transfer-vertical-square' as const
};